export default {
  image: 'A2_2_2.png',
  pdf: '220922_WA-EPS_001_A2_2_Rev02_ar.pdf',
  productData: {
    serialNumber: 'WA-EPS-001',
    technicalValues: {
      soundReductionIndex: {
        output: '43,8',
        value: 43.8
      },
      heatTransferCoefficient: {
        output: '0,12',
        value: 0.12
      },
      fireBehavior: {
        output: 'normalentflammbar (B2)',
        value: 'B2'
      },
      fireResistanceOuter: {
        output: 'F 30-B',
        value: 'F-30-B'
      },
      fireResistanceInner: {
        output: 'F 30-B',
        value: 'F-30-B'
      }
    },
    name: 'Wandaufbau mit EPS l Aufbau 1',
    construction: {
      composition: [
        {
          output: 'organischer Unterputz',
          type: 'render',
          title: { de: 'Putz' },
          value: 'org-1'
        },
        {
          output: '140 mm Sto-Dämmplatte Top 32',
          type: 'pinsulation', 
          title: { de: 'Dämmung' },
          value: 'pda-140'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'outerPlanking',
          title: { de: 'Beplankung Außen' },
          value: 'opg-12'
        },
        {
          output: '≥ 60/160',
          type: 'stand',
          title: { de: 'Ständer' },
          value: 'stae-160'
        },
        {
          output: '160 mm Glaswolle',
          type: 'compartmentInsulation',
          title: { de: 'Gefachdämmung' },
          value: 'cigw-160'
        },
        {
          output: '12,5 mm Gipsfaserplatte',
          type: 'innerPlanking1',
          title: { de: 'Beplankung Innen 1. Lage' },
          value: 'if-12'
        },
        {
          output: 'keine',
          type: 'innerPlanking2',
          title: { de: 'Beplankung Innen 2. Lage' },
          value: null
        }, 
        {
          output: 'keine',
          type: 'innerPlanking3',
          title: { de: 'Beplankung Innen 3. Lage' },
          value: null
        }
      ],
      sum: {
        output: '330,5',
        value: 330.5
      }
    }
  }
}
